import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import logger from "loglevel";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n/i18n";
logger.setLevel(process.env.NODE_ENV === "production" ? "info" : "debug");
ReactDOM.createRoot(document.getElementById("root")).render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
